import { BznavAppIds } from '@repo/common-utils';
import { DialogData } from '@repo/ui';

import { CiAuthenticationErrors, CiRequestTypes, SignInErrors, SocialItem, SocialItemType } from './types';

export const BZNAV_LAST_SIGN_IN_COOKIE_KEY = `B_LAST_SIGN_IN_TYPE.${process.env.NEXT_PUBLIC_ZENV}`;
export const BZNAV_EMAIL_SIGN_UP_AES_KEY = 'B_EMAIL_SIGN_UP_TEMPORARY_KEY';

export const APP_NAME: Record<BznavAppIds, string> = {
  'bznav-brand': '비즈넵 브랜드',
  'bznav-refund': '비즈넵 환급',
  'bznav-sena': '비즈넵 세나',
  'bznav-care': '비즈넵 케어',
  'bznav-plus': '비즈넵 플러스'
};

export const SIGN_IN_PAGE_CONTENT: Record<
  BznavAppIds,
  {
    imageUrl: string;
    title: string;
    subTitle: string;
  }
> = {
  'bznav-refund': {
    imageUrl: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/logos/logo_bznav-refund.png`,
    title: '300만명이 선택한 안심 환급',
    subTitle: '단 30초 만에 환급금 무료로 확인해보세요.'
  },
  'bznav-sena': {
    imageUrl: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/sena/logos/logo-bznav-sena.svg`,
    title: '세무·법률·노무 상담 AI 세나',
    subTitle: '간편 로그인하고 세나에게 질문하세요.'
  },
  'bznav-care': {
    imageUrl: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/care/logos/logo-bznav-care.svg`,
    title: '비즈넵 케어로 세무 걱정 끝',
    subTitle: '빈틈없는 세무기장 서비스로\n이제 사업에만 집중하세요.'
  },
  'bznav-brand': {
    imageUrl: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/brand/logos/logo-bznav-brand.svg`,
    title: '비즈넵 - 세무에서 자유로워지다',
    subTitle: '모든 세무고민\n비즈넵이 해결해드릴게요.'
  },
  'bznav-plus': {
    imageUrl: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/plus/logos/logo-bznav-plus.svg`,
    title: '비즈넵 플러스와 함께 성장하세요',
    subTitle: '비즈니스에 필요한 다양한 혜택과 서비스를\n하나의 플랫폼에서 만나보세요.'
  }
};

export const SIGN_IN_ERRORS: Record<SignInErrors, DialogData> = {
  kakao_email_required: {
    title: '이메일의 인증이 필요해요.',
    description: '카카오 계정 관리 페이지로 이동하여\n이메일을 인증하거나 이메일을 변경한 후에 가입해주세요.',
    buttons: {
      primary: {
        text: '카카오 계정 관리하기'
      },
      secondary: {}
    }
  },
  under_age_signup: {
    title: '만 14세 미만 미성년자는\n회원가입이 어려워요',
    description:
      '이용에 불편을 드려 죄송합니다.\n이용약관에 따라 만 14세 미만인 경우 회원가입 및 서비스 이용이 제한되고, 이와 관련된 개인정보를 수집하지 않아요.',
    buttons: {
      primary: {
        text: '돌아가기'
      }
    }
  },
  sign_failed: {
    title: '올바른 경로로 접속하지 않아\n로그인을 실패했어요'
  }
};

export const SOCIAL_ITEMS: Record<SocialItemType, SocialItem> = {
  naver: {
    imageUrl: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/logos/naver.svg`,
    buttonColor: 'bg-naver',
    textColor: 'text-neutral-foreground-inverse-main',
    text: '네이버로 시작하기',
    retryText: '이전 로그인한 네이버로 계속',
    circleButtonIconWidth: 26,
    rectangleButtonIconWidth: 16
  },
  kakao: {
    imageUrl: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/logos/kakao.svg`,
    buttonColor: 'bg-kakao',
    textColor: 'text-neutral-foreground-main',
    text: '카카오로 시작하기',
    retryText: '이전 로그인한 카카오로 계속',
    circleButtonIconWidth: 33,
    rectangleButtonIconWidth: 20
  },
  apple: {
    imageUrl: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/logos/apple.svg`,
    buttonColor: 'bg-apple',
    textColor: 'text-neutral-foreground-inverse-main',
    text: 'Apple로 시작하기',
    retryText: '이전 로그인한 Apple로 계속',
    circleButtonIconWidth: 22,
    rectangleButtonIconWidth: 18
  }
};

export const CI_AUTHENTICATION_ERROR: Record<CiAuthenticationErrors, DialogData> = {
  ci_mismatch: {
    title: '본인 인증 정보가 일치하지 않아요'
  },
  invalid_session: {
    title: '인증 세션이 만료되었어요'
  },
  invalid_integrity: {
    title: '인증 데이터가 유효하지 않아요'
  },
  invalid_request_no: {
    title: '요청 번호가 올바르지 않아요'
  },
  under_age_signup: {
    title: '만 14세 미만 미성년자는\n서비스 이용이 어려워요',
    description:
      '이용에 불편을 드려 죄송합니다.\n이용약관에 따라 만 14세 미만인 경우 회원가입 및 서비스 이용이 제한되고, 이와 관련된 개인정보를 수집하지 않아요.'
  },
  prepare_data_failed: {
    title: '본인 인증을 위한 정보를 불러올 수 없어요'
  },
  ci_process_failed: {
    title: '알 수 없는 이유로 본인 인증을 실패했어요'
  }
};

export const CI_RETURN_URL = 'ci_return_url';

export const AFTER_CI_QUERY_STATE = 'after_ci';
export const PASS_ENTRY_HISTORY_LENGTH = 'PASS_ENTRY_HISTORY_LENGTH';
export const PASS_EXIT_HISTORY_LENGTH = 'PASS_EXIT_HISTORY_LENGTH';

export const CI_REQUEST_TYPES: Record<'COLLECTION' | 'USER_UPDATE' | 'VERIFICATION', CiRequestTypes> = {
  COLLECTION: 'ci_collection',
  USER_UPDATE: 'user_update',
  VERIFICATION: 'ci_verification'
};
